import samplePage from './main-page';
// import pages from './pages';
// import other from './other';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [samplePage]
};

export default menuItems;
